import { render, staticRenderFns } from "./DNSMissingTXT.vue?vue&type=template&id=933f4d88&scoped=true&lang=html&"
import script from "./DNSMissingTXT.vue?vue&type=script&lang=js&"
export * from "./DNSMissingTXT.vue?vue&type=script&lang=js&"
import style0 from "./DNSMissingTXT.vue?vue&type=style&index=0&id=933f4d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933f4d88",
  null
  
)

export default component.exports